import { Controller } from 'stimulus'

import Rails from '@rails/ujs'
import axios from 'axios'

export default class extends Controller {
  static targets = ['amount', 'result', 'vatPercentage']
  static values = { url: String }

  connect() {
    axios.defaults.headers.common['X-CSRF-Token'] = Rails.csrfToken()
    this.calculate()
  }

  calculate() {
    axios.post(
      this.urlValue,
      {
        amount: this.amountTarget.value,
        vatPercentage: this.vatPercentageTarget.value
      }
    ).then((response) => {
      this.resultTarget.innerHTML = response.data.amountIncludingVat
    })
  }
}
